export default __webpack_public_path__ + "static/media/ribbon_label.80344926.svg";